import React, { useState, FC } from "react";
import Button from "@mui/material/Button";
import ConfirmSignModal from "../components/orderSummary/modals/ConfirmSign/ConfirmSignModal";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const StyledDiv = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-bewteen",
  flexDirection: "column",
  paddingBottom: 60,
  position: "relative",
  [theme.breakpoints.down("lg")]: {
    paddingBottom: 10,
  },
}));

const StyledSubmitButton = styled(Button)(({ theme }) => ({
  position: "absolute",
  top: 50,
  left: "4vw",
  width: "150%",
  [theme.breakpoints.down("lg")]: {
    position: "relative",
    top: 0,
    left: 0,
    width: "100%",
  },
}));

const StyledSpan = styled("span")({
  fontWeight: "bold",
  paddingLeft: 5,
  paddingRight: 5,
});

interface DealerProps {
  quoteNumber: number;
  status?: string;
  viewAllState?: boolean;
  isOrder?: boolean;
  isProduction?: boolean;
  cantSign?: string;
  dealerUrl: string;
  base64Pdf?: null | ArrayBuffer | string;
  canEditCustomCladColorAndFreightQuotePrice: boolean
}

const DealerPDF: FC<DealerProps> = ({
  quoteNumber,
  status,
  viewAllState,
  isOrder,
  isProduction,
  cantSign,
  dealerUrl,
  base64Pdf,
  canEditCustomCladColorAndFreightQuotePrice,
}) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const [loading, setLoading] = useState(false);

  const fileName = !isProduction
    ? `AGMillworks(PC-${quoteNumber})Dealer.pdf`
    : `AGMillworks(PC-${quoteNumber})Production.pdf`;

  const getBlobBase64 = async () => {
    if (!base64Pdf) return setLoading(false);
    setLoading(true);
    try {
      const reqBody = {
        base64PDF: base64Pdf.slice(String(base64Pdf).indexOf(",") + 1),
        fileName: fileName,
      };

      const reqHeaders = {
        headers: { "x-auth-token": sessionStorage.getItem("auth-token") },
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
      };
      const res = await axios.post(
        "/api/createEsignFolder",
        reqBody,
        reqHeaders,
      );

      sessionStorage.setItem(
        "esignURL",
        JSON.stringify(res.data.embeddedSigningSessions[0].embeddedSessionURL),
      );
      navigate("/esign");
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  if (dealerUrl) {
    return (
      <>
        {!isOrder && (
          <ConfirmSignModal
            open={open}
            handleClose={handleClose}
            handleSign={getBlobBase64}
            loading={loading}
            cantSign={cantSign || ""}
            canEditCustomCladColorAndFreightQuotePrice={canEditCustomCladColorAndFreightQuotePrice}
          />
        )}
        {viewAllState ? (
          <StyledDiv>
            <PDFButton
              dealerUrl={dealerUrl}
              fileName={fileName}
              viewAllState={true}
              isOrder={isOrder || false}
              status={status || ""}
              handleOpen={handleOpen}
            />
          </StyledDiv>
        ) : (
          <div style={{ padding: 10 }}>
            <PDFButton
              dealerUrl={dealerUrl}
              fileName={fileName}
              viewAllState={false}
              isOrder={isOrder || false}
              status={status || ""}
              handleOpen={handleOpen}
            />
          </div>
        )}
      </>
    );
  }

  return null;
};

interface Props {
  viewAllState: boolean;
  isOrder?: boolean;
  status: string;
  handleOpen: () => void;
  dealerUrl: string;
  fileName: string;
}

const PDFButton: FC<Props> = ({
  dealerUrl,
  fileName,
  viewAllState,
  isOrder,
  status,
  handleOpen,
}) => {
  return (
    <>
      <a
        href={dealerUrl}
        download={fileName}
        style={{ textDecoration: "none" }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "#21c7f5", color: "black" }}
        >
          <StyledSpan> Dealer </StyledSpan> Details
        </Button>
      </a>
      {!isOrder && status !== "Archived" && viewAllState && (
        <StyledSubmitButton
          onClick={handleOpen}
          variant="contained"
          color="customGrey"
          style={{ color: "white" }}
        >
          Sign / Submit <StyledSpan> Order </StyledSpan>
        </StyledSubmitButton>
      )}
    </>
  );
};

export default DealerPDF;
